import getPrefix from './getPrefix'
import downloadBlob from '@/utils/downloadBlob'
export default {
  getPrefix,
  downloadBlob
}
